export default __webpack_public_path__ + "static/media/fiercely-independent-img3.051b5775.jpg";